import { Link } from "react-router-dom";
import { CourseTypeEnum } from "../../enums";
import { InfoService } from "../../APIService/InfoService";
import { authObj, useAuthContext } from "../../context/authContext";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { Tooltip } from "react-tooltip";
interface ICoursesNavigationButtonsProps {
  previousCourseId: number | null;
  nextCourseId: number | null;
  courseType: CourseTypeEnum;
  currentCourseId: string | undefined;
}

export function CoursesNavigationButtons({
  previousCourseId: previousId,
  nextCourseId: nextId,
  courseType,
  currentCourseId,
}: ICoursesNavigationButtonsProps) {
  const { authInfo } = useAuthContext();
  const { enqueueSnackbar } = useSnackbar();
  const [secondAssignAttempt, setSecondAssignAttempt] = useState(false);

  return (
    <div
      style={{
        marginTop: "2rem",
        gap: "1rem",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-evenly",
      }}
    >
      {previousId && (
        <Link
          style={{ fontWeight: "550" }}
          to={`/${courseType.toLowerCase()}/${previousId}`}
        >
          Предыдущий курс
        </Link>
      )}
      <Link
        style={{ fontWeight: "550" }}
        to={`/print/course/${currentCourseId}`}
        target="_blank"
        data-tooltip-id="print-tooltip"
        data-tooltip-content={
          isNaN(authObj().id)
            ? "Зарегистрируйтесь, чтобы напечатать курс"
            : "Открыть страницу для печати"
        }
      >
        Напечатать
      </Link>
      <Tooltip id="print-tooltip" />
      <Link
        style={{ fontWeight: "550" }}
        to={`/learning`}
        data-tooltip-id="add-tooltip"
        data-tooltip-content={
          isNaN(authObj().id)
            ? 'Зарегистрируйтесь, чтобы добавить курс на страницу "Обучение"'
            : 'Добавить курс на страницу "Обучение"'
        }
        onClick={async (e) => {
          e.preventDefault();
          const alreadyAssigned = await InfoService.getAssignedCourses(
            authInfo.id,
          );

          let assignNow = true;
          if (
            alreadyAssigned.data.includes(Number(currentCourseId)) &&
            !secondAssignAttempt
          ) {
            enqueueSnackbar(
              `Курс ${currentCourseId} был добавлен ранее, если вы хотите его повторно добавить и сбросить статистику ответов нажмите еще раз`,
              {
                variant: "warning",
                anchorOrigin: { horizontal: "right", vertical: "top" },
              },
            );
            assignNow = false;
          }

          if (assignNow) {
            try {
              if (!currentCourseId) throw "err";
              await InfoService.assignCourse(
                authInfo.id,
                currentCourseId.trim(),
              );
              enqueueSnackbar(
                `Курс ${currentCourseId} добавлен в список Обучение`,
                {
                  variant: "success",
                  anchorOrigin: { horizontal: "right", vertical: "top" },
                },
              );
            } catch (e: any) {
              enqueueSnackbar(
                `Ошибка добавления курса ${currentCourseId}: ${e.response.data.message}`,
                {
                  variant: "error",
                  anchorOrigin: { horizontal: "right", vertical: "top" },
                },
              );
            }
            setSecondAssignAttempt(false);
          } else {
            setSecondAssignAttempt(true);
          }
          return assignNow;
        }}
      >
        Добавить
      </Link>
      <Tooltip id="add-tooltip" />
      {nextId && (
        <Link
          style={{ fontWeight: "550" }}
          to={`/${courseType.toLowerCase()}/${nextId}`}
        >
          Следующий курс
        </Link>
      )}
    </div>
  );
}
